import type { FaireProductEntity } from "../../entity_types/product";

export const p_pd5dsnmn9k: FaireProductEntity = {
  token: "p_pd5dsnmn9k",
  type: "product",
  name: "Puka Shell & Sea Foam Glass Chain Bracelet",
  brandToken: "b_d5ty4bqhca",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/c11023e2ff9be3edfeb4660caa1b4f826ef030596f24ddd94b742ce310dac143.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dc01539fde1390c687f5bd5151d728792d044bb43539dbda4650e4632eb33ff8.jpeg",
    "https://cdn.faire.com/fastly/d43be2235b080c94998f9fefddd2a6020b4b43c728d34629aa44c3f5759644f2.jpeg",
    "https://cdn.faire.com/fastly/939362b7ef851124bc4a633a8594e96c3ac2e79f5b5bcc0f3984d7b956401b13.jpeg",
    "https://cdn.faire.com/fastly/0ac4cdc3f9403b29edb221104c809a603a61f3bcdd65ce36511a4f3f90eb255d.jpeg",
    "https://cdn.faire.com/fastly/cdee3fcb0be2eace2f077c393e142a89ef347084b9cec8d00c112179364dc8a7.jpeg",
    "https://cdn.faire.com/fastly/d5f1727d4f38084917df52b0418574660a7edb8559239568db999f223652d3a1.jpeg",
    "https://cdn.faire.com/fastly/c7ebf84549299874f64664bb85e051390a1adfff9f46455d215517a966dee4c5.jpeg",
  ],
  priceDollars: 17,
  description:
    "This dainty bracelet features cute little puka shells and tiny sea foam colored tumbled glass. They dangle on a 2.3mm 14k gold filled or sterling silver (not shown) adjustable cable chain. \n\nPuka shells and glass vary slightly in size and shape.",
  tags: [],
  msrpDollars: 34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:36.031Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
